import React from "react";
import { Link } from "react-router-dom";

const cream = "#F5F0E8";
const darkBg = "#1a1025";
const mutedCream = "rgba(245,240,232,0.6)";
const purple = "#8B5CF6";

export default function LabManagerTerms() {
  return (
    <div className="min-h-screen" style={{ backgroundColor: darkBg, color: cream }}>
      <nav className="max-w-7xl mx-auto px-4 py-6 flex items-center justify-between">
        <Link to="/labmanager" className="flex items-center gap-3">
          <span className="text-2xl">🔬</span>
          <span className="text-xl font-bold" style={{ color: cream }}>LabManager</span>
        </Link>
      </nav>

      <div className="max-w-3xl mx-auto px-4 py-12">
        <h1 className="text-3xl md:text-4xl font-bold mb-8" style={{ color: cream }}>Terms of Service</h1>
        <p className="text-sm mb-8" style={{ color: mutedCream }}>Last updated: March 7, 2026</p>

        <div className="space-y-8 text-sm leading-relaxed" style={{ color: mutedCream }}>
          <section>
            <h2 className="text-lg font-semibold mb-3" style={{ color: cream }}>1. Acceptance of Terms</h2>
            <p>By downloading, installing, or using LabManager ("the Software"), you agree to be bound by these Terms of Service. If you do not agree, do not use the Software.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3" style={{ color: cream }}>2. Description of Service</h2>
            <p>LabManager is a desktop application for managing research lab operations. It is provided in two tiers:</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li><strong style={{ color: cream }}>Free:</strong> Full-featured local application for individual use. No account required.</li>
              <li><strong style={{ color: cream }}>Team ($50/month):</strong> Cloud sync, real-time collaboration, and team management features. Requires an account and active subscription.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3" style={{ color: cream }}>3. Free Tier</h2>
            <p>The free tier is provided as-is with no warranty. You may use it for personal or professional research purposes without restriction. No account, registration, or payment is required.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3" style={{ color: cream }}>4. Team Subscription</h2>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>The Team tier is billed monthly at $50/month per team.</li>
              <li>Payment is processed through Stripe. You agree to Stripe's terms of service.</li>
              <li>You may cancel at any time. Access continues through the end of the billing period.</li>
              <li>Refunds are not provided for partial months.</li>
              <li>We reserve the right to change pricing with 30 days notice.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3" style={{ color: cream }}>5. Your Data</h2>
            <p>You retain full ownership of all data you enter into LabManager. For free tier users, all data is stored locally and we have no access to it. For Team tier users, data is synced to our cloud infrastructure as described in our <Link to="/labmanager/privacy" style={{ color: purple }}>Privacy Policy</Link>.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3" style={{ color: cream }}>6. Acceptable Use</h2>
            <p>You agree not to:</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Reverse engineer, decompile, or disassemble the Software</li>
              <li>Use the Team sync service to store illegal content</li>
              <li>Attempt to gain unauthorized access to other teams' data</li>
              <li>Resell or redistribute the Software</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3" style={{ color: cream }}>7. Disclaimer of Warranty</h2>
            <p>THE SOFTWARE IS PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. PLEXYS DOES NOT WARRANT THAT THE SOFTWARE WILL BE UNINTERRUPTED OR ERROR-FREE.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3" style={{ color: cream }}>8. Limitation of Liability</h2>
            <p>IN NO EVENT SHALL PLEXYS BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE USE OF THE SOFTWARE, INCLUDING BUT NOT LIMITED TO LOSS OF DATA.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3" style={{ color: cream }}>9. Changes to Terms</h2>
            <p>We may update these terms from time to time. Continued use of the Software after changes constitutes acceptance of the new terms.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3" style={{ color: cream }}>10. Contact</h2>
            <p>Questions? Contact us at <a href="mailto:support@plexys.co" style={{ color: purple }}>support@plexys.co</a>.</p>
          </section>
        </div>
      </div>

      <footer className="py-10 border-t" style={{ borderColor: "rgba(139,92,246,0.15)" }}>
        <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-4 text-sm" style={{ color: mutedCream }}>
          <p>&copy; {new Date().getFullYear()} Plexys. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/labmanager" className="hover:opacity-100 transition">LabManager</Link>
            <Link to="/labmanager/privacy" className="hover:opacity-100 transition">Privacy Policy</Link>
            <Link to="/" className="hover:opacity-100 transition">Plexys Home</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
